// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__F6Xhy","error":"SearchInput_error__Y4mp2","searchWrapper":"SearchInput_searchWrapper__4PW3d","searchIcon":"SearchInput_searchIcon__DUIMa"};